import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";


function Projects() {
  const [fullscreenImg, setFullscreenImg] = React.useState(null);

  const handleImageClick = (src) => {
    setFullscreenImg(src);
  };

  const handleCloseFullscreen = () => {
    setFullscreenImg(null);
  };

  // Add the fullscreen modal component here
  const FullscreenModal = ({ src, onClose }) => {
    if (!src) return null;

    return (
      <div
        className="fullscreen-modal"
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1050,
          cursor: 'pointer',
        }}
        onClick={onClose}
      >
        <div
          className="fullscreen-modal-content"
          style={{
            position: 'relative',
            maxWidth: '90%',
            maxHeight: '90%',
          }}
          onClick={e => e.stopPropagation()}
        >
          <button
            className="fullscreen-modal-close"
            style={{
              position: 'absolute',
              top: '10px',
              right: '10px',
              fontSize: '20px',
              color: '#fff',
              backgroundColor: 'transparent',
              border: 'none',
              cursor: 'pointer',
              zIndex: 1100,
            }}
            onClick={onClose}
          >
            &times;
          </button>
          <img
            src={src}
            alt="Fullscreen"
            style={{
              display: 'block',
              maxWidth: '100vw',
              maxHeight: '100vh',
              width: 'auto',
              height: 'auto',
              objectFit: 'contain',
            }}
          />
        </div>
      </div>
    );
  };

  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              media={[
                { type: "image", src: "/images/HK_watch.png" },
                { type: "image", src: "/images/HK_ride.png" },
                { type: "video", src: "/images/HK_trailer.mp4" },
              ]}
              isBlog={false}
              title="The Housekeeper"
              description="The Housekeeper is my first VR game developed in Unity. You wake up in a mansion where the housekeeper has strict rules about living there. You try to agitate the housekeeper by breaking all those rules and find your escape."
              ghLink="https://github.com/ErayRonald/TheHousekeeper"
              onImageClick={handleImageClick}
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              media={[
                { type: "image", src: "/images/Pybird.png" },
              ]}
              isBlog={false}
              title="Pybird"
              description="My first programming language was Python, so I tried remaking the classic game 'Flappy Bird' in Python using the Pygame library. The game features a bird that you control by clicking to avoid obstacles. The goal is to achieve the highest score possible by navigating through the gaps between the pipes."
              ghLink="https://github.com/ErayRonald/Pybird"
              onImageClick={handleImageClick}
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              media={[
                { type: "image", src: "/images/manychunks.png" },
                { type: "video", src: "/images/minecraft_chunk.mp4" },
              ]}
              isBlog={false}
              title="Minecraft Procedual Chunk Generation"
              description="This project is a Minecraft-like application where I implemented a procedural chunk generation algorithmn. The 'game' generates chunks as you move around and unloads chunks when you don't need them to optimize performance. It is made in Unity using C#."
              ghLink="https://github.com/ErayRonald/minecraft-chunk-generation"
              onImageClick={handleImageClick}
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              media={[
                { type: "image", src: "/images/20240531_140740.jpg" },
                { type: "image", src: "/images/IMG_0998.jpg" },
                { type: "image", src: "/images/IMG_1006.jpg" },
                { type: "image", src: "/images/Screenshot 2025-05-26 215718.png" },
                { type: "image", src: "/images/IMG20240530121940.jpg" },
                { type: "video", src: "/images/bonsi_demo.mp4" },
              ]}
              isBlog={false}
              title="Bonsi - The driving plant"
              description="Bonsi is a plant that can drive itself around. It uses a sensor to detect obstacles and a water sensor and pump with a reservoir to keep itself hydrated. While my team worked on the fun app where you can manage your plant inspired by the app Pou, I worked on the IOT part that consists of the automatic watering system. For some reason I decided to make it into a driving plant😅. The plant is controlled by an esp32 using C++."
              onImageClick={handleImageClick}
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              media={[
                  { type : "image", src: "/images/Screenshot 2025-05-30 184848.png" },
                  { type: "image", src: "/images/1748347579969.jpg" },
                  { type: "image", src: "/images/labbach.jpg" },
                  { type: "image", src: "/images/presentation1.jpg" },
                  { type: "image", src: "/images/presentation2.jpg" },
                  { type: "image", src: "/images/1748347579205.jpg" },
              ]}
              isBlog={false}
              title="VR SIM blood samples"
              description="For my bachelor project I am currently working with my team to make a simulation of a labmachine. This machine is used to test blood samples, so lab students can learn how to work with the machine before getting their hands on a real one at their internship."
              onImageClick={handleImageClick}
            />
          </Col>

            <Col md={4} className="project-card">
            <ProjectCard
              media={[
                { type: "image", src: "/images/Screenshot 2025-05-25 142955.png" },
                { type: "video", src: "/images/RNGenius_Demo.mp4" },
               ]}
              isBlog={false}
              title="RNGenius"
              description="RNGenius is an app that simplifies decision-making by keeping categorized lists of items. Users can choose from these categories with the extra option to collaborate with friends, families, colleagues, etc., which makes the difficult decision-making process much more enjoyable!"
              onImageClick={handleImageClick}
            />
          </Col>
            
          <Col md={4} className="project-card">
            <ProjectCard
              media={[
                { type: "image", src: "/images/unity.png" },
               ]}
              isBlog={false}
              title="Game WIP"
              description="Currently developing a 3D game in Unity. The game is still in the early stages of development, but I am excited to share more details soon!"
              onImageClick={handleImageClick}
            />
          </Col>
            
          <Col md={4} className="project-card">
            <ProjectCard
              media={[
                { type: "image", src: "/images/minipc.png" },
               ]}
              isBlog={false}
              title="Self-hosting"
              description="Currently experimenting with self-hosting and linux on my new mini PC. Running things like Syncthing, vaultwarden, Tailscale, Minecraft servers, and more."
              onImageClick={handleImageClick}
            />
          </Col>
            
        </Row>
      </Container>
      {/* Render the FullscreenModal here */}
      <FullscreenModal src={fullscreenImg} onClose={handleCloseFullscreen} />
    </Container>
  );
}

export default Projects;
